var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datetime',{attrs:{"input-class":"form-control","type":"datetime","moment-locale":"es","phrases":{ok: 'Aceptar', cancel: 'Cancelar'}},on:{"input":function($event){return _vm.changed()}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }